var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.501 9C13.501 8.58579 13.1652 8.25 12.751 8.25H5.25098C4.83676 8.25 4.50098 8.58579 4.50098 9C4.50098 9.41421 4.83676 9.75 5.25098 9.75H12.751C13.1652 9.75 13.501 9.41421 13.501 9Z",
    fill: "#199FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.001 9C18.001 5.27208 14.9789 2.25 11.251 2.25H6.75098C3.02306 2.25 0.000976562 5.27208 0.000976562 9V14.25C0.000976562 15.0784 0.67255 15.75 1.50098 15.75H11.251C14.9789 15.75 18.001 12.7279 18.001 9ZM11.251 3.75H6.75098C3.85148 3.75 1.50098 6.10051 1.50098 9V14.25H11.251C14.1505 14.25 16.501 11.8995 16.501 9C16.501 6.10051 14.1505 3.75 11.251 3.75Z",
    fill: "#199FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.da7ecfae8b1b582e67c0c70e6118fbd1.svg";
export { ForwardRef as ReactComponent };